import { InferType, object, ref } from 'yup';

import { passwordRules } from './sign-up-schema';

const ResetPasswordSchema = object({
  password: passwordRules.required('Password is required'),
  passwordConfirmation: passwordRules
    .oneOf([ref('password')], 'Your passwords do not match')
    .required('Please confirm your password'),
});

export { ResetPasswordSchema };
export type ResetPasswordSchemaType = InferType<typeof ResetPasswordSchema>;
